import { render, staticRenderFns } from "./minimal.vue?vue&type=template&id=728bc751&scoped=true"
import script from "./minimal.vue?vue&type=script&lang=js"
export * from "./minimal.vue?vue&type=script&lang=js"
import style0 from "./minimal.vue?vue&type=style&index=0&id=728bc751&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728bc751",
  null
  
)

export default component.exports